<div class="modal-backdrop" (click)="closeModal()"></div>
<div class="modal" style="width: 800px; max-width: 90vw;">
  <div class="modal-header">
    <h2 class="modal-title">Transactions for Invoice {{invoiceNo}}</h2>
    <span class="icon-btn" (click)="closeModal()" style="cursor: pointer; color: #6b7280; font-size: 1.25rem;">
      <i class="fas fa-times"></i>
    </span>
  </div>
  <div class="modal-body" style="padding: 24px; max-height: 70vh; overflow-y: auto;">
    <div class="overflow-x-auto md:overflow-x-visible rounded-lg">
    <table class="modern-table min-w-full" >
      <thead>
        <tr>
          <th>Transaction ID</th>
          <th>Type</th>
          <th>Invoice No.</th>
          <th>Retailer</th>
          <th>Amount</th>
          <th>Method</th>
          <th>Status</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let txn of transactions">
          <td>{{txn.gateway_payment_id || 'N/A'}}</td>
          <td>
            <span [class]="getTypeClass(txn.type)"
              style="padding:4px 12px; border-radius:12px; font-size:0.85rem; font-weight:500;">
              {{txn.type | titlecase}}
            </span>
          </td>
          <td>{{txn.invoice_no || 'N/A'}}</td>
          <td>{{txn.retailer_name}}</td>
          <td>₹{{txn.amount | number}}</td>
          <td>{{txn.payment_method}}</td>
          <td>
            <span [class]="getStatusClass(txn.status)"
              style="padding:4px 12px; border-radius:12px; font-size:0.85rem; font-weight:500;">
              {{txn.status | titlecase}}
            </span>
          </td>
          <td>{{txn.transaction_date | date:'short'}}</td>
        </tr>
        <tr *ngIf="!loading && transactions.length === 0">
          <td colspan="7" style="text-align:center; padding:24px; color:#888;">No transactions found</td>
        </tr>
        <tr *ngIf="loading">
          <td colspan="7" style="text-align:center; padding:24px; color:#888;">Loading...</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer" style="padding-left: 24px; padding-right: 24px; padding-bottom: 24px;">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
  </div>
</div>